module.exports = __webpack_public_path__ + "public/hws/images/logo.svg";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/logo.svg
// module id = 100
// module chunks = 0